import React, { Ref } from 'react';
import styled from 'styled-components';
import { Space } from 'antd';

import { StyledMainTitle } from 'common/styling/mixins';

type Props = {
  title: string;
  subtitle?: string;
  step?: {
    currentStepLabel: string;
    current: number;
    total: number;
  };
  isStickyTop?: boolean;
  children?: React.ReactElement;
  elemRef?: Ref<HTMLDivElement>;
};

const Wrapper = styled.div`
  background-color: white;
`;

const HeaderWrapper = styled.header`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 32px;
  h1,
  p {
    color: ${(props) => (props.theme ? props.theme.colors.primary.main : 'blue')};
    line-height: 1.5rem;
    margin: 0;
    font-size: 1.5rem;
  }
  h2 {
    color: ${(props) => (props.theme ? props.theme.colors.primary.main : 'blue')};
    line-height: 1.5rem;
    margin: 0;
    font-size: 1.125rem;
  }
`;

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Title = StyledMainTitle;

const Subtitle = styled.h2``;

const StepWrapper = styled.div`
  position: absolute;
  right: 0;
`;

const HeaderWithSteps: React.FC<Omit<Props, 'isStickyTop'>> = ({ title, subtitle, step, children, elemRef }) => (
  <Wrapper ref={elemRef}>
    <HeaderWrapper>
      <Space direction="vertical" align="center" style={{ textAlign: 'justify', width: '80%' }}>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Space>
      {!!step && (
        <StepWrapper>
          <Space direction="vertical" align="center">
            <p>
              <strong>{step.current}</strong>/<span>{step.total}</span>
            </p>
            <p>{step.currentStepLabel}</p>
          </Space>
        </StepWrapper>
      )}
    </HeaderWrapper>
    {children}
  </Wrapper>
);

const WithSticky: React.FC<Props> = ({ isStickyTop, ...props }) => {
  if (isStickyTop) {
    return (
      <StickyHeader>
        <HeaderWithSteps {...props} />
      </StickyHeader>
    );
  }
  return <HeaderWithSteps {...props} />;
};

export default WithSticky;
